let currentIndex = 0;
const carousel = document.querySelector('.parent-slider');
const carouselItems = document.querySelectorAll('.hp-video-section');
let autoSlideInterval = null;
let isProgrammaticScroll = false;

function showSlide(index) {
  isProgrammaticScroll = true;
  currentIndex = index;
  const offset = index * carouselItems[0].clientWidth;
  carousel.scrollTo({ left: offset, behavior: 'smooth' });

  // Reset flag after animation
  setTimeout(() => { isProgrammaticScroll = false }, 500);
}

function nextSlide() {
  currentIndex = (currentIndex + 1) % carouselItems.length;
  showSlide(currentIndex);
}

function startAutoSlide() {
  if (autoSlideInterval) return;
  autoSlideInterval = setInterval(nextSlide, 4000);
}

function stopAutoSlide() {
  clearInterval(autoSlideInterval);
  autoSlideInterval = null;
}

// Optional: Update currentIndex if user scrolls manually
carousel.addEventListener('scroll', () => {
  if (isProgrammaticScroll) return;
  const scrolledIndex = Math.round(carousel.scrollLeft / carouselItems[0].clientWidth);
  currentIndex = scrolledIndex;
}, { passive: true });

// Don't pause on hover or scroll
startAutoSlide();
